import {createSelector} from 'reselect';

const gsConfigSelector = (state = {}) => state.gsConfig;
export const hostSelector = createSelector(gsConfigSelector, ({domain = 'www.stubhub.ie'} = {}) =>
  domain ? domain : 'www.stubhub.ie',
);
